export function validators() {
    return {
        name: (group, value) => {
            if (!value?.trim()) {
                return "This field is required.";
            }
            return undefined;
        },
        pubs: (group, value) => {
            if (!value?.length) {
                return "At least one Publisher needs to be added, in order to create a Publisher Group.";
            }
            return undefined;
        }
    };
}
//# sourceMappingURL=validators.js.map